export default __webpack_public_path__ + "static/media/CF5AF0C7-562B-4330-B496-8A2EE283E128_1_105_c.bd8927c6.jpg";